import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const groupApi = createApi({
  reducerPath: 'groupApi',
  keepUnusedDataFor: 1,
  baseQuery: fetchBaseQuery({
    baseUrl: '/Group',
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getStudentsInGroup: builder.query({
      query: ({ groupId, atMoment, includeExpelled }) => ({
        url: `/StudentsInGroup`,
        method: 'GET',
        params: { groupId, atMoment, includeExpelled }
      }),
    }),
    getGroupsByPattern: builder.query({
      query: ({ data }) => ({
        url: `/GetGroupsByPattern`,
        method: 'GET',
        params: data
      }),
    }),
    setGroupFlow: builder.mutation({
      query: ({ data }) => ({
        url: `/SetGroupFlow`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }),
    getAvailableSemestersForGroup: builder.query({
      query: ({ data }) => ({
        url: `/GetAvailableSemestersForGroup`,
        method: 'GET',
        params: data
      }),
    }),
    getGroupInfo: builder.query({
      query: ({ data }) => ({
        url: `/GetGroupInfo`,
        method: 'GET',
        params: data
      }),
    }),
    getAccounts: builder.query({
      query: ({ data }) => ({
        url: `/GetAccounts`,
        method: 'GET',
        params: data
      }),
    }),
  }),
});

export const { 
  useGetStudentsInGroupQuery,
  useLazyGetGroupsByPatternQuery,
  useSetGroupFlowMutation,
  useLazyGetAvailableSemestersForGroupQuery,
  useLazyGetGroupInfoQuery,
  useLazyGetAccountsQuery
} = groupApi;
